import React, { useState, useEffect, useRef } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { IoIosAdd, IoIosRemove } from "react-icons/io";
import { Link, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import logoIcon from "../assets/qsi 01@1.5x (1).png";
import logoName from "../assets/qsi 02@1.5x (1).png";

const Navbar = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [activeServiceNowGroup, setActiveServiceNowGroup] = useState(null);
  const [isMobileServiceNowOpen, setIsMobileServiceNowOpen] = useState(false);
  const dropdownRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    setDropdownOpen(false);
    setMobileMenuOpen(false);
    setActiveServiceNowGroup(null);
    setIsMobileServiceNowOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleDropdown = () => setDropdownOpen((prev) => !prev);
  const toggleServiceNowGroup = (group) => {
    setActiveServiceNowGroup((prev) => (prev === group ? null : group));
  };

  const menuLink =
    "relative text-yellow-400 font-semibold tracking-wide transition-all duration-300 hover:text-white after:content-[''] after:absolute after:left-0 after:-bottom-1 after:w-0 after:h-[3px] after:bg-orange-400 hover:after:w-full after:transition-all after:duration-300";

  const dropdownItemClass =
    "block text-white hover:text-yellow-400 transition-all duration-300";

  const dropdownTitleClass =
    "text-yellow-400 font-bold text-lg border-b-2 border-orange-400 pb-1 mb-2";

  return (
    <nav
      className="fixed top-0 left-0 w-full z-50 shadow-lg font-[Poppins]"
      style={{
        background: "linear-gradient(to right, #0f172a, #020617)", // solid dark navy gradient (fully opaque)
        borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
      }}
    >
      <div className="max-w-screen-xl mx-auto px-4 py-2 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="h-20 flex items-center gap-0">
          <img
            src={logoIcon}
            alt="Logo Icon"
            className="h-[75px] w-auto object-contain object-center"
            style={{ imageRendering: "crisp-edges" }}
          />
          <img
            src={logoName}
            alt="Company Name"
            className="h-[75px] w-auto object-contain object-center"
            style={{ imageRendering: "crisp-edges" }}
          />
        </Link>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center space-x-8">
          <Link to="/" className={menuLink}>Home</Link>

          {/* Dropdown */}
          <div className="relative" ref={dropdownRef}>
            <button onClick={toggleDropdown} className={menuLink}>
              ServiceNow Services
            </button>
            {isDropdownOpen && (
              <div className="absolute top-12 left-1/2 -translate-x-1/2 w-[850px] bg-black/90 p-6 grid grid-cols-4 gap-6 rounded-md shadow-2xl border border-gray-700 z-50">
                {/* IT Workflow */}
                <div>
                  <h4 className={dropdownTitleClass}>IT Workflow</h4>
                  <ul className="space-y-2">
                    {["ITSM", "ITOM", "ITBM", "ITAM", "DevOps", "Security Ops", "GRC"].map((name, idx) => (
                      <li key={idx}>
                        <HashLink smooth to={`/servicesnow#${name.toLowerCase().replace(" ", "")}`} className={dropdownItemClass}>
                          {name}
                        </HashLink>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Employee Workflow */}
                <div>
                  <h4 className={dropdownTitleClass}>Employee Workflow</h4>
                  <ul className="space-y-2">
                    {["HRSD", "Workplace", "Legal", "Procurement", "Safe Workplace"].map((name, idx) => (
                      <li key={idx}>
                        <HashLink smooth to={`/servicesnow#${name.toLowerCase().replace(" ", "")}`} className={dropdownItemClass}>
                          {name}
                        </HashLink>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Customer Workflow */}
                <div>
                  <h4 className={dropdownTitleClass}>Customer Workflow</h4>
                  <ul className="space-y-2">
                    {["Customer Service", "Field Service", "Connected Ops", "Financial Ops", "Telecom Mgmt"].map((name, idx) => (
                      <li key={idx}>
                        <HashLink smooth to={`/servicesnow#${name.toLowerCase().replace(" ", "")}`} className={dropdownItemClass}>
                          {name}
                        </HashLink>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Creator Workflow */}
                <div>
                  <h4 className={dropdownTitleClass}>Creator Workflow</h4>
                  <ul className="space-y-2">
                    {["App Engine", "Integration Hub", "Automation Engine"].map((name, idx) => (
                      <li key={idx}>
                        <HashLink smooth to={`/servicesnow#${name.toLowerCase().replace(" ", "")}`} className={dropdownItemClass}>
                          {name}
                        </HashLink>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}
          </div>

          <Link to="/OtherServices" className={menuLink}>Other Services</Link>
            <Link to="/Career " className={menuLink}>Career</Link>
          <Link to="/contact" className={menuLink}>Contact Us</Link>
        </div>

        {/* Mobile Icon */}
        <div className="md:hidden">
          <button onClick={() => setMobileMenuOpen(!isMobileMenuOpen)} className="text-yellow-400">
            {isMobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-black/95 text-white px-6 pb-4 space-y-4">
          <Link to="/" onClick={() => setMobileMenuOpen(false)} className="block py-2 font-semibold text-yellow-400">
            Home
          </Link>

          {/* ServiceNow Mobile */}
          <button
            onClick={() => setIsMobileServiceNowOpen((prev) => !prev)}
            className="w-full text-left py-2 font-semibold flex justify-between items-center text-yellow-400"
          >
            ServiceNow Services
            {isMobileServiceNowOpen ? <IoIosRemove /> : <IoIosAdd />}
          </button>

          {isMobileServiceNowOpen && (
            <div className="space-y-3 ml-3">
              {[
                ["IT Workflow", ["ITSM", "ITOM", "ITBM", "ITAM", "DevOps", "Security Ops", "GRC"]],
                ["Employee Workflow", ["HRSD", "Workplace", "Legal", "Procurement", "Safe Workplace"]],
                ["Customer Workflow", ["Customer Service", "Field Service", "Connected Ops", "Financial Ops", "Telecom Mgmt"]],
                ["Creator Workflow", ["App Engine", "Integration Hub", "Automation Engine"]],
              ].map(([title, links], idx) => (
                <div key={idx}>
                  <button
                    onClick={() => toggleServiceNowGroup(title)}
                    className="flex justify-between w-full items-center text-yellow-300 font-bold"
                  >
                    {title}
                    {activeServiceNowGroup === title ? <IoIosRemove /> : <IoIosAdd />}
                  </button>
                  {activeServiceNowGroup === title && (
                    <ul className="ml-4 space-y-2">
                      {links.map((name, i) => (
                        <li key={i}>
                          <HashLink
                            smooth
                            to={`/servicesnow#${name.toLowerCase().replace(" ", "")}`}
                            onClick={() => {
                              setMobileMenuOpen(false);
                              setIsMobileServiceNowOpen(false);
                              setActiveServiceNowGroup(null);
                            }}
                            className="block text-white hover:text-yellow-400"
                          >
                            {name}
                          </HashLink>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          )}

          <Link to="/OtherServices" onClick={() => setMobileMenuOpen(false)} className="block py-2 font-semibold text-yellow-400">
            Other Services
          </Link>
           <Link to="/Career " onClick={() => setMobileMenuOpen(false)} className="block py-2 font-semibold text-yellow-400">
            Career 
          </Link>
          <Link to="/contact" onClick={() => setMobileMenuOpen(false)} className="block py-2 font-semibold text-yellow-400">
            Contact Us
          </Link>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
